// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"220":"c85d9e8c","488":"0a1a1c08"}[chunkId] + ".chunk.js");